import Raven from 'raven-js';
import { GET_PUBLIC_FEATURE_FLAGS } from 'pricing-pages-api/feature-flags/queries';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
import { getUtk } from 'pricing-pages-ui/earlyRequester/earlyRequesterUtils';
import { dataFetchingClient, DEFAULT_CHIRP_TIMEOUT } from 'pricing-pages-ui/utils/dataFetchingClient';
import { getCountryCodeFromLocale } from 'pricing-pages-ui/v2/utils/countryCodeUtils';
export function fetchPublicPricingPageDetails() {
  const browserLocale = getPreferredLanguage().toLowerCase() || 'en-us';
  const utk = getUtk() || '';
  // Type cast necessary: CHIRP expects specific CountryCode type, but we receive
  // string | undefined from getCountryCodeFromLocale(). Backend validates the actual value.
  const preferredCountryCode = getCountryCodeFromLocale();
  dataFetchingClient.query({
    query: GET_PUBLIC_FEATURE_FLAGS,
    variables: {
      utk,
      browserLocale,
      preferredCountryCode: preferredCountryCode
    },
    context: {
      timeout: DEFAULT_CHIRP_TIMEOUT
    }
  }).catch(error => {
    Raven.captureException(error, {
      fingerprint: ['failed-to-fetch-public-feature-flags']
    });
  });
}